import React  from 'react';
import { Link,useHistory, } from 'react-router-dom';
import { selectMenu  } from '.././../actions/index';
import { useDispatch,useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from "./sidebar/Sidebar";
import DesktopMenu from "./DesktopMenu";
import { useMediaQuery } from 'react-responsive'

const Header = (match) => { 
    
  const history = useHistory({forceRefresh:true});
    
  const dispatch = useDispatch();
  dispatch(selectMenu(match)); 
  const loginuser = useSelector((state) => state.setUserlog); 

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })

    
    return (
        <>
            {   isTabletOrMobile || isPortrait ? <><Sidebar/><div className='mob-top'></div></> : 
              <DesktopMenu data={match}/> }   
        </>
    )
 }

export default Header
